import React, {
  Component,
  MouseEvent,
  ReactNode,
  useEffect,
  useState,
} from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import { Form } from "react-bootstrap";
import axios from "axios";
import { useStore } from "../store";
import Card from "react-bootstrap/Card";
import { Colors } from "../utils/style";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  IconDefinition,
  faHandHoldingDollar,
  faHandHoldingMedical,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from 'react-i18next';



type Prop = {
  title: string;
  description?: string;
  icon?: IconDefinition;
  children?: ReactNode;
  width?: string;
  titleHeight?: string;
};
function UseCaseCardComponent(props: Prop) {
  const [isHovered, setIsHovered] = useState(false);
  const { t } = useTranslation("ActionCardComponent");

  const handleHover = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  return (
    <>
      <Card
        style={{
          borderRadius: "10px",
          borderColor: isHovered ? "green" : "",
          backgroundColor: Colors.GRAY,
          height: "100%",
        }}
        onMouseOver={handleHover}
        onMouseLeave={handleMouseLeave}
      >
        <Card.Body>
          <Card.Title
            style={{
              display: "flex",
              gap: "1rem",
              alignItems: "center",
              marginBottom: "1rem",
            }}
          >
            <FontAwesomeIcon
              icon={props.icon || faHandHoldingMedical}
              size="2x"
              color="green"
            />
            {props.title}
          </Card.Title>
          <Card.Text style={{ height: "5rem" }}>{props.description}</Card.Text>
          <Button variant="success">
            {t("ViewDetails")}
          </Button>
        </Card.Body>
      </Card>
    </>
  );
}

export default UseCaseCardComponent;
